/**
 * @Time    : 2024/01/10 11:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { postAuthLogout } from '@/services/auth';
import { redirectLogin } from '@/utils/login';
import { EditOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Spin, message } from 'antd';
import { createStyles } from 'antd-style';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback } from 'react';
import HeaderDropdown from '../HeaderDropdown';

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span>{currentUser?.name || currentUser?.username}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  try {
    return await postAuthLogout();
  } catch (error) {
    return { success: false };
  }
};

export type AvatarDropdownProps = {
  menu?: boolean;
  children?: React.ReactNode;
};
export const AvatarDropdown: React.FC<AvatarDropdownProps> = ({ menu, children }) => {
  const { styles } = useStyles();

  const { initialState } = useModel('@@initialState');

  const onMenuClick = useCallback((event: MenuInfo) => {
    const { key } = event;
    switch (key) {
      case 'logout': {
        const hideLoading = message.loading('正在处理中，请稍候...');
        loginOut().then((response) => {
          const { success = false } = response;
          if (success) {
            hideLoading();
            redirectLogin();
          }
        });
        return;
      }
      case 'center': {
        window.open(USER_CENTER_URL);
        return;
      }
      case 'forget': {
        window.open(USER_FORGET_PASSWD_URL);
        return;
      }
      default: {
        history.push(`/account/${key}`);
      }
    }
  }, []);

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心',
          },
          {
            key: 'forget',
            icon: <EditOutlined />,
            label: '修改密码',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      {children}
    </HeaderDropdown>
  );
};
